var _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8, _rect9, _rect10, _rect11, _rect12, _rect13, _rect14, _rect15, _rect16, _rect17, _rect18, _rect19, _rect20, _rect21, _rect22, _rect23, _rect24, _rect25, _rect26, _rect27, _rect28, _rect29, _rect30, _rect31, _rect32;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgLearnMoreWithoutLogin = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 694,
  height: 600,
  viewBox: "0 0 694 600",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
  x: 360,
  y: 90,
  width: 294,
  height: 28,
  rx: 4,
  fill: "#DEDDD7"
})), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
  x: 360,
  y: 138,
  width: 121,
  height: 17.8125,
  rx: 4,
  fill: "#DEDDD7"
})), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
  x: 360,
  y: 167.062,
  width: 220,
  height: 17.8125,
  rx: 4,
  fill: "#DEDDD7"
})), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
  x: 360,
  y: 196.125,
  width: 262,
  height: 17.8125,
  rx: 4,
  fill: "#DEDDD7"
})), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
  x: 360,
  y: 225.188,
  width: 121,
  height: 17.8125,
  rx: 4,
  fill: "#DEDDD7"
})), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
  x: 360,
  y: 225.188,
  width: 121,
  height: 17.8125,
  rx: 4,
  fill: "#DEDDD7"
})), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
  x: 360,
  y: 255,
  width: 116,
  height: 37,
  rx: 4,
  fill: "#DEDDD7"
})), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
  x: 360,
  y: 332,
  width: 60,
  height: 60,
  rx: 4,
  fill: "#DEDDD7"
})), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
  x: 432,
  y: 332,
  width: 121,
  height: 12.8929,
  rx: 4,
  fill: "#DEDDD7"
})), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
  x: 432,
  y: 353.036,
  width: 220,
  height: 12.8929,
  rx: 4,
  fill: "#DEDDD7"
})), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
  x: 432,
  y: 374.071,
  width: 262,
  height: 12.8929,
  rx: 4,
  fill: "#DEDDD7"
})), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
  x: 432,
  y: 395.107,
  width: 121,
  height: 12.8929,
  rx: 4,
  fill: "#DEDDD7"
})), _rect13 || (_rect13 = /*#__PURE__*/React.createElement("rect", {
  x: 432,
  y: 395.107,
  width: 121,
  height: 12.8929,
  rx: 4,
  fill: "#DEDDD7"
})), _rect14 || (_rect14 = /*#__PURE__*/React.createElement("rect", {
  x: 360,
  y: 428,
  width: 60,
  height: 60,
  rx: 4,
  fill: "#DEDDD7"
})), _rect15 || (_rect15 = /*#__PURE__*/React.createElement("rect", {
  x: 432,
  y: 428,
  width: 121,
  height: 12.8929,
  rx: 4,
  fill: "#DEDDD7"
})), _rect16 || (_rect16 = /*#__PURE__*/React.createElement("rect", {
  x: 432,
  y: 449.036,
  width: 220,
  height: 12.8929,
  rx: 4,
  fill: "#DEDDD7"
})), _rect17 || (_rect17 = /*#__PURE__*/React.createElement("rect", {
  x: 432,
  y: 470.071,
  width: 262,
  height: 12.8929,
  rx: 4,
  fill: "#DEDDD7"
})), _rect18 || (_rect18 = /*#__PURE__*/React.createElement("rect", {
  x: 432,
  y: 491.107,
  width: 121,
  height: 12.8929,
  rx: 4,
  fill: "#DEDDD7"
})), _rect19 || (_rect19 = /*#__PURE__*/React.createElement("rect", {
  x: 432,
  y: 491.107,
  width: 121,
  height: 12.8929,
  rx: 4,
  fill: "#DEDDD7"
})), _rect20 || (_rect20 = /*#__PURE__*/React.createElement("rect", {
  x: 360,
  y: 524,
  width: 60,
  height: 60,
  rx: 4,
  fill: "#DEDDD7"
})), _rect21 || (_rect21 = /*#__PURE__*/React.createElement("rect", {
  x: 432,
  y: 524,
  width: 121,
  height: 12.8929,
  rx: 4,
  fill: "#DEDDD7"
})), _rect22 || (_rect22 = /*#__PURE__*/React.createElement("rect", {
  x: 432,
  y: 545.036,
  width: 220,
  height: 12.8929,
  rx: 4,
  fill: "#DEDDD7"
})), _rect23 || (_rect23 = /*#__PURE__*/React.createElement("rect", {
  x: 432,
  y: 566.071,
  width: 262,
  height: 12.8929,
  rx: 4,
  fill: "#DEDDD7"
})), _rect24 || (_rect24 = /*#__PURE__*/React.createElement("rect", {
  x: 432,
  y: 587.107,
  width: 121,
  height: 12.8929,
  rx: 4,
  fill: "#DEDDD7"
})), _rect25 || (_rect25 = /*#__PURE__*/React.createElement("rect", {
  x: 432,
  y: 587.107,
  width: 121,
  height: 12.8929,
  rx: 4,
  fill: "#DEDDD7"
})), _rect26 || (_rect26 = /*#__PURE__*/React.createElement("rect", {
  width: 328,
  height: 38,
  rx: 4,
  fill: "#DEDDD7"
})), _rect27 || (_rect27 = /*#__PURE__*/React.createElement("rect", {
  y: 62,
  width: 328,
  height: 522,
  rx: 12,
  fill: "#EBEAE3"
})), _rect28 || (_rect28 = /*#__PURE__*/React.createElement("rect", {
  x: 28,
  y: 90,
  width: 272,
  height: 28,
  rx: 4,
  fill: "#DEDDD7"
})), _rect29 || (_rect29 = /*#__PURE__*/React.createElement("rect", {
  x: 28,
  y: 146,
  width: 272,
  height: 44,
  rx: 4,
  fill: "#DEDDD7"
})), _rect30 || (_rect30 = /*#__PURE__*/React.createElement("rect", {
  x: 28,
  y: 202,
  width: 272,
  height: 44,
  rx: 4,
  fill: "#DEDDD7"
})), _rect31 || (_rect31 = /*#__PURE__*/React.createElement("rect", {
  x: 28,
  y: 258,
  width: 272,
  height: 44,
  rx: 4,
  fill: "#DEDDD7"
})), _rect32 || (_rect32 = /*#__PURE__*/React.createElement("rect", {
  x: 28,
  y: 342,
  width: 272,
  height: 44,
  rx: 4,
  fill: "#DEDDD7"
})));
export default SvgLearnMoreWithoutLogin;